export default "__VITE_ASSET__acfa60cf__"